import { c as _c } from "react/compiler-runtime";
import { createContext, useContext, type ReactNode } from 'react';
interface NewProfileDialogContextType {
  openNewProfileDialog: () => void;
}
const NewProfileDialogContext = createContext<NewProfileDialogContextType | undefined>(undefined);
interface NewProfileDialogProviderProps {
  children: ReactNode;
  onOpenChange: (open: boolean) => void;
}
export const NewProfileDialogProvider = t0 => {
  const $ = _c(7);
  const {
    children,
    onOpenChange
  } = t0;
  let t1;
  if ($[0] !== onOpenChange) {
    t1 = () => {
      onOpenChange(true);
    };
    $[0] = onOpenChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const openNewProfileDialog = t1;
  let t2;
  if ($[2] !== openNewProfileDialog) {
    t2 = {
      openNewProfileDialog
    };
    $[2] = openNewProfileDialog;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children || $[5] !== t2) {
    t3 = <NewProfileDialogContext.Provider value={t2}>{children}</NewProfileDialogContext.Provider>;
    $[4] = children;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export const useNewProfileDialog = () => {
  const context = useContext(NewProfileDialogContext);
  if (context === undefined) {
    throw new Error("useNewProfileDialog must be used within a NewProfileDialogProvider");
  }
  return context;
};